import { createContext, useContext, useState, useEffect, useCallback } from "react";

const CartContext = createContext(null);
const KEY = "vinci_cart";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      const raw = JSON.parse(localStorage.getItem(KEY)) || [];
      return raw.map((i) => ({ ...i, key: i.key || (i.diameter ? `${i.id}__${i.diameter}` : i.id), diameter: i.diameter || "" }));
    } catch { return []; }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(items)); }, [items]);

  const add = useCallback((product, quantity = 1, diameter = "") => {
    const key = diameter ? `${product.id}__${diameter}` : product.id;
    setItems((prev) => {
      const found = prev.find((i) => i.key === key);
      if (found) return prev.map((i) => (i.key === key ? { ...i, quantity: i.quantity + quantity } : i));
      return [...prev, { key, id: product.id, name: product.name, brand: product.brand, price: product.price, unit: product.unit, image: product.image, moq: product.moq || 1, diameter, quantity }];
    });
    setOpen(true);
  }, []);

  const setQty = useCallback((key, quantity) => {
    setItems((prev) => prev.map((i) => (i.key === key ? { ...i, quantity: Math.max(1, quantity) } : i)));
  }, []);

  const remove = useCallback((key) => setItems((prev) => prev.filter((i) => i.key !== key)), []);
  const clear = useCallback(() => setItems([]), []);

  const count = items.reduce((s, i) => s + i.quantity, 0);
  const subtotal = items.reduce((s, i) => s + i.price * i.quantity, 0);

  return (
    <CartContext.Provider value={{ items, add, setQty, remove, clear, count, subtotal, open, setOpen }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
